import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f38ae2ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "popup" }
const _hoisted_2 = { class: "pop-content" }
const _hoisted_3 = { class: "collapse-item-title" }

import { watchEffect, computed } from 'vue';
import useIdentify from '@/composables/useIdentify';
import { useStore } from 'vuex';
import {
  useTrack,
  FunctionIdEnum,
  EventTypeEnum,
} from '@/components/sendMetrics';


export default /*#__PURE__*/_defineComponent({
  __name: 'FixedIdentifyPopup',
  props: {
  enabled: {
    type: Boolean,
    default: true,
  },
  position: {
    type: [],
    required: false,
  },
},
  setup(__props) {

const props = __props;

const { track } = useTrack();
const store = useStore();
const mapsAdded = computed(() => store.getters['maps/cartoMapsAdd']);



const { loading, mapList, popupExist, fetchIdentifies } = useIdentify();

const activeKeys = computed(() =>
  mapList.value.map((map) => map.id.toString()),
);

const showPopup = computed(() => {
  return props.enabled && props.position;
});

const updatePopup = () => {
  if (props.position && mapsAdded.value.length > 0) {
    const lng = props.position[0];
    const lat = props.position[1];
    fetchIdentifies(
      mapsAdded.value.map((map) => ({
        baseUrl: map.baseUrl,
        vizId: map.id,
        apiKey: map.privacy == 'PRIVATE' ? store.state.user.api_key : '',
      })),
      lng,
      lat,
    );
  }
};

const handleClickMap = (map: any) => {
  track(FunctionIdEnum.globalLayer_nav_showLegends, EventTypeEnum.CLICK, map);
};

watchEffect(() => {
  if (props.enabled) {
    track(FunctionIdEnum.globalLayer_earth_identifyLocation, EventTypeEnum.CLICK);
    updatePopup();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(_component_el_empty, {
        description: _ctx.$t('FixedIdentifyPopup.nolayers'),
        "image-size": 80
      }, null, 8, ["description"]), [
        [_vShow, mapsAdded.value.length == 0]
      ]),
      _withDirectives(_createVNode(_component_el_empty, {
        description: _ctx.$t('FixedIdentifyPopup.noidentify'),
        "image-size": 80
      }, null, 8, ["description"]), [
        [_vShow, 
          mapsAdded.value.length > 0 && _unref(mapList).length == 0 && !_unref(loading) && !_unref(popupExist)
        ]
      ]),
      _withDirectives(_createVNode(_component_el_empty, {
        description: _ctx.$t('FixedIdentifyPopup.noinfo'),
        "image-size": 80
      }, null, 8, ["description"]), [
        [_vShow, 
          mapsAdded.value.length > 0 && _unref(mapList).length == 0 && !_unref(loading) && _unref(popupExist)
        ]
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_collapse, {
        modelValue: activeKeys.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeKeys).value = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mapList), (map) => {
            return (_openBlock(), _createBlock(_component_el_collapse_item, {
              key: map.id,
              name: map.id.toString(),
              onClick: () => handleClickMap(map)
            }, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, _toDisplayString(map.name), 1)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(map.identifies, (identify) => {
                  return (_openBlock(), _createBlock(_component_el_descriptions, {
                    key: identify.id,
                    title: identify.name,
                    column: 1,
                    size: "small",
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(identify.fields, (value, key) => {
                        return (_openBlock(), _createBlock(_component_el_descriptions_item, {
                          key: key,
                          label: key
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(value), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["title"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["name", "onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])), [
        [_directive_loading, _unref(loading)]
      ])
    ])
  ], 512)), [
    [_vShow, showPopup.value]
  ])
}
}

})